import { Role } from '@/auth/utils'

export default [
  {
    path: '/management/subscription',
    name: 'manage-subscription',
    component: () => import('@/views/management/subscription-manage/SubscriptionList.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Subscriptions',
        },
      ],
      authorize: [Role.Admin],
    },
  },
  {
    path: '/management/subscription/detail/:id',
    name: 'manage-subscription-detail',
    component: () => import('@/views/management/subscription-manage/detail/SubscriptionDetail.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Subscriptions',
          to: '/management/subscription',
        },
        {
          text: 'Detail',
        },
      ],
      authorize: [Role.Admin],
    },
  },

  {
    path: '/management/qpadm-samples',
    name: 'qpadm-samples',
    component: () => import('@/views/ancestry-data/qpadm/qpadm-samples/QpadmSampleList.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Qpadm Samples',
        },
      ],
      authorize: [Role.Admin],
    },
  },
  {
    path: '/management/qpadm-samples/:id',
    name: 'qpadm-samples-save',
    component: () => import('@/views/ancestry-data/qpadm/qpadm-samples/qpadm-sample-detail/QpadmSampleSave.vue'),
    meta: {
      breadcrumb: [
        {
          text: 'Qpadm Sample',
          to: '/management/qpadm-samples',
        },
        {
          text: 'Save',
        },
      ],
      authorize: [Role.Admin],
    },
  },
]
